import { Component, OnInit, Input, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DniValidationDigitComponent } from '../dni-validation-digit/dni-validation-digit.component';
import { VirtualStoreService } from 'src/app/services/virtual-store.service';
import { DetailedOrderItem } from 'src/app/models/virtual-store/detailed-order-item.model';
import { OrderItemUpdateRequest } from 'src/app/models/virtual-store/order-item-update-request.model';
import { forkJoin } from 'rxjs';
import { OrderItemService } from 'src/app/services/order-item.service';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-virtual-store-dni-validator',
  templateUrl: './virtual-store-dni-validator.component.html',
  styleUrls: ['./virtual-store-dni-validator.component.scss']
})
export class VirtualStoreDniValidatorComponent implements OnInit {
  @Input() clientCode: string;
  dni: string = null;
  errorMessage: string = null;
  orderItemList: DetailedOrderItem[] = [];
  constructor(private virtualStoreService: VirtualStoreService,
    private matDialogRef: MatDialogRef<DniValidationDigitComponent>,
    @Inject(MAT_DIALOG_DATA) private input: any,
    private orderItemService: OrderItemService,
    private authService: AuthService
    ) { }

  ngOnInit() {
    this.clientCode = this.input.clientCode;
    this.orderItemList = this.input.orderItemList;
  }
  async validateDni() {
    if (this.dni) {
      let dniValidation = await this.virtualStoreService.isDniValid(this.clientCode, this.dni).toPromise();
      if (dniValidation.valid) {
        await this.updateOrderItemList(this.orderItemList);
        this.close(true, this.dni, dniValidation.data);
        this.errorMessage = null;
      } else { this.errorMessage = 'El número de DNI ingresado no coincide con el del titular de la cuenta.'; }
    } else {
      this.errorMessage = 'Ingrese un número de documento.';
    }
  }
  close(proceed: boolean, dni: string, fullName: string) {
    this.matDialogRef.close({ proceed, dni, fullName });
  }

  updateOrderItemList(orderItemList: DetailedOrderItem[]) {
    let updateRequestList = orderItemList.map(orderItem => {
      let update = new OrderItemUpdateRequest();
      update.id = orderItem.id;
      update.clientCode = this.clientCode;
      update.count = orderItem.count;
      update.monthlyPaymentCount = orderItem.monthlyPaymentCount;
      update.documentType=this.authService.getBasicData().documentType;
      update.documentNumber=this.authService.getBasicData().documentNumber;
      update.isFnb=this.authService.getCreditLineFNB().isCreditLineFNB;
      return this.orderItemService.updatePendingOne(update)
    });

    return forkJoin(updateRequestList).toPromise();
  }
}
